import { Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import ChevronLeftSmallFilled from '../../../../../assets/img/ChevronLeftSmallFilled.svg';
import { TLocalesKeys } from '../../../../../types';
import { goBackCopilot } from '../../../../messageChannel/postNewMessages';
import { headerFullPageDataHooks } from '../HeaderFullPage.dataHooks';
import style from '../styles.scss';
import s from './styles.scss';

export const CopilotDefaultTitle: FC = () => {
  const { t } = useTranslation();

  return (
    <Box className={style.copilotAppHeaderTitleWrapper} gap="8px">
      <ChevronLeftSmallFilled onClick={goBackCopilot} className={s.chevronLeft} />
      <Heading
        className={style.copilotAppHeaderTitle}
        size="medium"
        dataHook={headerFullPageDataHooks.title()}
      >
        {t<TLocalesKeys>('widget_title_ai_chatbot')}
      </Heading>
    </Box>
  );
};
